import formatDateHelper from "./formatDate"

const convertDateToSeconds = (_seconds) => {
  if (!_seconds) return ""

  return formatDateHelper(new Date(parseInt(_seconds) * 1000))
}

export default convertDateToSeconds
